module.exports = __webpack_public_path__ + "img/icon-ai.9f7818d1.svg";